import React from 'react';

class TemplateBasePage extends React.Component {
  onSubscriptionBtnClick(plan) {
    alert('onSubscriptionBtnClick');
  }

  renderBase() {
    return (
      <>
      </>
    );
  }
}

export default TemplateBasePage;
